import { AxiosResponse } from 'axios';
import { KeyValue, KeyValueDefault } from '@/main/models/common';
import { Result } from '@/main/models/common/resultResponse';
import {
  ChangeImportanceOrderRequest,
  PackageTypeDomainRequest,
  PackageTypeGetAllByCoutryIdRequest,
  PackageTypeRequest
} from '@/main/models/request';
import { PackageTypeResponse } from '@/main/models/response';

export abstract class IPackageApi {
  abstract getDomain(
    request: PackageTypeDomainRequest
  ): Promise<AxiosResponse<Result<KeyValueDefault[]>>>;

  abstract getAllByCoutryId(
    request: PackageTypeGetAllByCoutryIdRequest
  ): Promise<AxiosResponse<Result<PackageTypeResponse>>>;

  abstract getByGuidPackageType(
    guidPackageType: string
  ): Promise<AxiosResponse<Result<PackageTypeResponse>>>;

  abstract changeImportanceOrder(
    request: ChangeImportanceOrderRequest
  ): Promise<AxiosResponse<Result<any>>>;

  abstract save(
    request: PackageTypeRequest
  ): Promise<AxiosResponse<Result<PackageTypeResponse>>>;

  abstract update(
    request: PackageTypeRequest
  ): Promise<AxiosResponse<Result<PackageTypeResponse>>>;

  abstract delete(
    guidPackageType: string
  ): Promise<AxiosResponse<Result<PackageTypeResponse>>>;
}

